import { useEffect, useState } from "react"
import Uploader from "./UploadDemo"


export default function FileEditDemo({}) {

    return (<>

            <h1>File Edit Demos</h1> 
             
            <br/><hr/><br/>
            <Uploader/>
    </>)
}
